import {values} from "@Common/utils/objects";

export const getStreet = (r) => values(r.addresses)[0];